module.exports = __webpack_public_path__ + "img/lunbo123.f60ed5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo123.png
// module id = p7df
// module chunks = 0